import { useAnalytics } from 'use-analytics';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { changeTrip, resetTrips } from '../../../store/slices/trip';
import { initFlightSearchRequest } from '../../../store/slices/flight';
import { setFlightTripSearchInputs } from '../../../store/slices/tripSearch';
import ModalSpinner from '../../ModalSpinner';
import { InitialFlightFilters, TravelTypes } from '../../../constants';
import Button from '../../Button';

const ResultsExpirationModal = () => {
  const { track } = useAnalytics();
  const { isNdcEnabled, expirationDuration } = useSelector(
    (state) => state.tripSearch.searchResult,
  );
  const dispatch = useDispatch();
  const [doShowModal, setDoShowModal] = useState(false);
  const { ignoreCachedResultsForModes } = useSelector((store) => store.trip);
  const searchInputs = useSelector((store) => store.tripSearch.searchInputs);
  const { flight: flightSearchInput = {} } = searchInputs;

  const handleRefresh = () => {
    setDoShowModal(false);
    dispatch(resetTrips());
    dispatch(
      setFlightTripSearchInputs({
        ...InitialFlightFilters,
        hasUserInteractedWithFlightList: false,
        foundTotalFlights: undefined,
        searchProgress: undefined,
      }),
    );
    dispatch(
      changeTrip({
        field: 'ignoreCachedResultsForModes',
        value: _.concat(ignoreCachedResultsForModes, [TravelTypes.flight]),
      }),
    );
    dispatch(
      initFlightSearchRequest({
        ...flightSearchInput,
        ...InitialFlightFilters,
        isTripSearch: true,
        isNewSearch: true,
      }),
    );
    track('resultsPage_offerExpired.refreshClicked');
  };

  useEffect(() => {
    if (isNdcEnabled) {
      const timer = setTimeout(() => {
        setDoShowModal(true);
      }, expirationDuration * 1000);
      return () => clearTimeout(timer);
    }
    return () => {};
  }, [expirationDuration, isNdcEnabled]);

  return doShowModal ? (
    <ModalSpinner isOpen doHidelogo size="xs">
      <div className="flex h-1/2 w-full items-center justify-center">
        <div className="flex flex-col items-start px-4 py-2">
          <h1 className="text-2xl">Refresh Required</h1>
          <p className="text-sm mt-3">
            The current offers have expired. Please refresh the page to get the latest offers.
          </p>
          <Button onClick={handleRefresh} size={Button.buttonSizes.SM} className="mt-3">
            <span>Refresh</span>
          </Button>
        </div>
      </div>
    </ModalSpinner>
  ) : (
    <></>
  );
};

export default ResultsExpirationModal;
